import useWindowDimensions from './useWindowDimensions'
function toNumber (value : any) {
    let acceptedNumber = ['0','1', '2', '3', '4', '5', '6', '7', '8', '9']
    value = value.toString()
    let numberValue = ''
    while (value.length>0) {
        let currentValue = value.substr(0,1)
        if(acceptedNumber.includes(currentValue))
            numberValue += currentValue
        value =value.substr(1)
    }
    return numberValue
}

function toPrice(value:any) {
    value = toNumber(value).toString()
    let price = ''
    while (value.length>3) {
		price = value.substr(-3) + ' ' + price
		value = value.slice(0,-3)
    }
    price = value + '.' + price
	price=price.slice(0,-1)

    return price
}

function isMobileDevice() { 
    if( navigator.userAgent.match(/iPhone/i)
    || navigator.userAgent.match(/webOS/i)
    || navigator.userAgent.match(/Android/i)
    || navigator.userAgent.match(/iPad/i)
    || navigator.userAgent.match(/iPod/i)
    || navigator.userAgent.match(/BlackBerry/i)
    || navigator.userAgent.match(/Windows Phone/i)
    ){
       return true;
     }
    else {
       return false;
     }
   }

export {toPrice, toNumber, useWindowDimensions, isMobileDevice}